import { ComponentProps } from 'react';

export function PresentationScreen({ ...props }: ComponentProps<'svg'>) {
  return (
    <svg
      {...props}
      width="36"
      height="32"
      viewBox="0 0 36 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31 19H5V5H2V20C2 21.1 2.9 22 4 22H16.5V24.9387L12 29.4387C11.4154 30.0232 11.4154 30.9713 12 31.5562C12.5842 32.1405 13.5319 32.1412 14.1169 31.5575L18 27.6812L21.8806 31.5619C22.4676 32.1488 23.42 32.1461 24.0037 31.556C24.5851 30.9681 24.5824 30.0216 23.9979 29.4366L19.5 24.9375V22H32C33.1 22 34 21.1 34 20V5H31V19ZM34.5 0H1.4975C0.67 0 0 0.670625 0 1.49688C0 2.32313 0.67 3 1.4975 3H34.5037C35.3312 3 36 2.32938 36 1.50312C36 0.676875 35.3312 0 34.5 0Z"
        fill="currentColor"
      />
    </svg>
  );
}
